import apiClient from './plugins/axios'
import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import './styles/main.css'
import './styles/global-styles.css'
import router from './router'
import store from './store'
import * as filters from './plugins/filters'
import Clipboard from 'v-clipboard'
import { pageBuilder } from '@myissue/vue-website-page-builder'
import './assets/global-fonts.css'
import i18n from './plugins/i18n'

loadFonts()

const app = createApp(App)
  .use(store)
  .use(vuetify)
  .use(router)
  .use(Clipboard)
  .use(pageBuilder)
  .use(i18n)
app.config.globalProperties.$filters = filters
app.config.globalProperties.$axios = apiClient
app.mount('#app')

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {})
  })
}

